import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4e7a80da = () => interopDefault(import('../pages/benutzer.vue' /* webpackChunkName: "pages/benutzer" */))
const _28fbd1e0 = () => interopDefault(import('../pages/hypothekenprofile.vue' /* webpackChunkName: "pages/hypothekenprofile" */))
const _27b55fb2 = () => interopDefault(import('../pages/institute/index.vue' /* webpackChunkName: "pages/institute/index" */))
const _3c3911bb = () => interopDefault(import('../pages/kundenliste/index.vue' /* webpackChunkName: "pages/kundenliste/index" */))
const _7d9c04c3 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _afebbec6 = () => interopDefault(import('../pages/mailcoach.vue' /* webpackChunkName: "pages/mailcoach" */))
const _6f30432a = () => interopDefault(import('../pages/neue-leads/index.vue' /* webpackChunkName: "pages/neue-leads/index" */))
const _a1103af0 = () => interopDefault(import('../pages/status.vue' /* webpackChunkName: "pages/status" */))
const _28d88f9c = () => interopDefault(import('../pages/zinssaetze.vue' /* webpackChunkName: "pages/zinssaetze" */))
const _56c83c16 = () => interopDefault(import('../pages/institute/hypothekenprofile.vue' /* webpackChunkName: "pages/institute/hypothekenprofile" */))
const _385fecc7 = () => interopDefault(import('../pages/kundenliste/neu.vue' /* webpackChunkName: "pages/kundenliste/neu" */))
const _a739750e = () => interopDefault(import('../pages/neue-leads/scores.vue' /* webpackChunkName: "pages/neue-leads/scores" */))
const _98173ca8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _575c3854 = () => interopDefault(import('../pages/kontakte/_slug.vue' /* webpackChunkName: "pages/kontakte/_slug" */))
const _3a827073 = () => interopDefault(import('../pages/kundenliste/_slug.vue' /* webpackChunkName: "pages/kundenliste/_slug" */))
const _508fd418 = () => interopDefault(import('../pages/kundenliste/_customer/ai-chat.vue' /* webpackChunkName: "pages/kundenliste/_customer/ai-chat" */))
const _38788fcc = () => interopDefault(import('../pages/kundenliste/_customer/ai-documents.vue' /* webpackChunkName: "pages/kundenliste/_customer/ai-documents" */))
const _06d5f9cd = () => interopDefault(import('../pages/kundenliste/_customer/kontakte/neu.vue' /* webpackChunkName: "pages/kundenliste/_customer/kontakte/neu" */))
const _2dcfe098 = () => interopDefault(import('../pages/kundenliste/_customer/objekte/neu.vue' /* webpackChunkName: "pages/kundenliste/_customer/objekte/neu" */))
const _c484e7c0 = () => interopDefault(import('../pages/kundenliste/_customer/objekte/_slug.vue' /* webpackChunkName: "pages/kundenliste/_customer/objekte/_slug" */))
const _9cf66fa2 = () => interopDefault(import('../pages/kundenliste/_customer/ai-documents-floorplan/_media/_page.vue' /* webpackChunkName: "pages/kundenliste/_customer/ai-documents-floorplan/_media/_page" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/benutzer",
    component: _4e7a80da,
    name: "benutzer"
  }, {
    path: "/hypothekenprofile",
    component: _28fbd1e0,
    name: "hypothekenprofile"
  }, {
    path: "/institute",
    component: _27b55fb2,
    name: "institute"
  }, {
    path: "/kundenliste",
    component: _3c3911bb,
    name: "kundenliste"
  }, {
    path: "/login",
    component: _7d9c04c3,
    name: "login"
  }, {
    path: "/mailcoach",
    component: _afebbec6,
    name: "mailcoach"
  }, {
    path: "/neue-leads",
    component: _6f30432a,
    name: "neue-leads"
  }, {
    path: "/status",
    component: _a1103af0,
    name: "status"
  }, {
    path: "/zinssaetze",
    component: _28d88f9c,
    name: "zinssaetze"
  }, {
    path: "/institute/hypothekenprofile",
    component: _56c83c16,
    name: "institute-hypothekenprofile"
  }, {
    path: "/kundenliste/neu",
    component: _385fecc7,
    name: "kundenliste-neu"
  }, {
    path: "/neue-leads/scores",
    component: _a739750e,
    name: "neue-leads-scores"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }, {
    path: "/kontakte/:slug?",
    component: _575c3854,
    name: "kontakte-slug"
  }, {
    path: "/kundenliste/:slug",
    component: _3a827073,
    name: "kundenliste-slug"
  }, {
    path: "/kundenliste/:customer/ai-chat",
    component: _508fd418,
    name: "kundenliste-customer-ai-chat"
  }, {
    path: "/kundenliste/:customer/ai-documents",
    component: _38788fcc,
    name: "kundenliste-customer-ai-documents"
  }, {
    path: "/kundenliste/:customer/kontakte/neu",
    component: _06d5f9cd,
    name: "kundenliste-customer-kontakte-neu"
  }, {
    path: "/kundenliste/:customer/objekte/neu",
    component: _2dcfe098,
    name: "kundenliste-customer-objekte-neu"
  }, {
    path: "/kundenliste/:customer/objekte/:slug?",
    component: _c484e7c0,
    name: "kundenliste-customer-objekte-slug"
  }, {
    path: "/kundenliste/:customer/ai-documents-floorplan/:media?/:page?",
    component: _9cf66fa2,
    name: "kundenliste-customer-ai-documents-floorplan-media-page"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
